import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/deals')({
  component: DealsLayout,
});

function DealsLayout() {
  return <Outlet />;
}
